// API URL configuration
export const API_URL = 'https://shop.konpremeucstore.com/api';

// Telegram configuration
export const TELEGRAM_BOT_USERNAME = 'konpreme_uc_bot';
export const TELEGRAM_BOT_TOKEN = '8065472322:AAEa4sDUcthOidNO7TtYlVxrV_SJiBzWDIE';
